<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'แก้ไขข้อมูล Certificate Authority' : 'เพิ่มข้อมูล Certificate Authority' }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" [class.view-only-form]="viewOnly">
  <form [formGroup]="certificateAuthorityForm">
    @if (!viewOnly) {
      <div class="row mb-3">
        <div class="col-sm-4"><label class="form-label required">Certificate File (.cer/.crt/.pem)</label></div>
        <div class="col-sm-8">
          <input type="file" class="form-control form-control-sm" accept=".cer,.crt,.pem"
                 (change)="onCertificateSelected($event)" [disabled]="previewing || uploadingForSave || isSubmitting">
          @if (selectedFile) {
            <small class="text-muted">ไฟล์ที่เลือก: {{ selectedFile.name }}</small>
          }
          @if (hasSecureDownloadTarget()) {
            <div class="mt-1">
              <a href="" (click)="downloadCurrentCertificate($event)">ดาวน์โหลดไฟล์ที่อัปโหลด</a>
            </div>
          }
        </div>
      </div>
      @if (previewing) {
        <div class="alert alert-info py-2">กำลังอ่านรายละเอียดจากไฟล์ใบรับรอง...</div>
      }
      @if (uploadingForSave) {
        <div class="alert alert-info py-2">กำลังอัปโหลดไฟล์ใบรับรองเพื่อบันทึกข้อมูล...</div>
      }
      @if (uploadErrorMessage) {
        <div class="alert alert-danger py-2">{{ uploadErrorMessage }}</div>
      }
    }

    @if (!viewOnly && !isEditMode && !hasUploadedCertificate) {
      <div class="alert alert-warning py-2">
        กรุณาเลือกไฟล์ใบรับรองก่อน ระบบจะแสดงรายละเอียดจากไฟล์ `.crt` หลังจากอ่านข้อมูลสำเร็จ
      </div>
    }

    @if (viewOnly || isEditMode || hasUploadedCertificate) {
      <div class="row mb-3">
        <div class="col-sm-4"><label for="issuerCn" class="form-label mb-0 required">Issuer CN</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="issuerCn" formControlName="issuerCn"
                 [readonly]="readonlyCertificateFields">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="subjectCn" class="form-label mb-0 required">Subject CN</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="subjectCn" formControlName="subjectCn"
                 [readonly]="readonlyCertificateFields">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="issuerO" class="form-label mb-0">Issuer O</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="issuerO" formControlName="issuerO"
                 [readonly]="readonlyCertificateFields">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="issuerOu" class="form-label mb-0">Issuer OU</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="issuerOu" formControlName="issuerOu"
                 [readonly]="readonlyCertificateFields">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="issuerC" class="form-label mb-0">Issuer C</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="issuerC" formControlName="issuerC"
                 [readonly]="readonlyCertificateFields">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="subjectO" class="form-label mb-0">Subject O</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="subjectO" formControlName="subjectO"
                 [readonly]="readonlyCertificateFields">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="subjectOu" class="form-label mb-0">Subject OU</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="subjectOu" formControlName="subjectOu"
                 [readonly]="readonlyCertificateFields">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="subjectC" class="form-label mb-0">Subject C</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="subjectC" formControlName="subjectC"
                 [readonly]="readonlyCertificateFields">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label class="form-label mb-0">Valid From</label></div>
        <div class="col-sm-8">
          <app-date-time-input [control]="certificateAuthorityForm.get('validFrom')" inputId="validFrom"
                               mode="date" size="sm" [readonly]="readonlyCertificateFields"></app-date-time-input>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label class="form-label mb-0">Valid To</label></div>
        <div class="col-sm-8">
          <app-date-time-input [control]="certificateAuthorityForm.get('validTo')" inputId="validTo"
                               mode="date" size="sm" [readonly]="readonlyCertificateFields"></app-date-time-input>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="certificateFile" class="form-label mb-0">Certificate File</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="certificateFile" formControlName="certificateFile" readonly>
          @if (hasSecureDownloadTarget()) {
            <small class="text-muted">ชื่อไฟล์: {{ getCertificateDownloadFileName() }}</small>
          }
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="revocationUrl" class="form-label mb-0">Revocation URL</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="revocationUrl" formControlName="revocationUrl">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="state" class="form-label mb-0">สถานะ</label></div>
        <div class="col-sm-8">
          <select class="form-select form-select-sm" id="state" formControlName="state">
            <option [ngValue]="1">เผยแพร่</option>
            <option [ngValue]="0">ไม่เผยแพร่</option>
          </select>
        </div>
      </div>

      @if (isEditMode) {
        <div class="row mb-3">
          <div class="col-sm-4"><label for="recordedBy" class="form-label mb-0">ผู้บันทึก</label></div>
          <div class="col-sm-8"><input id="recordedBy" class="form-control form-control-sm" [value]="recordedByDisplay" readonly></div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-4"><label for="recordedAt" class="form-label mb-0">วันที่บันทึก</label></div>
          <div class="col-sm-8"><input id="recordedAt" class="form-control form-control-sm" [value]="recordedAtDisplay" readonly></div>
        </div>
      }
    }
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link" (click)="activeModal.close()">ยกเลิก</button>
  @if (!viewOnly) {
    <button type="button" class="btn btn-primary btn-sm btn-custom"
            (click)="save()" [disabled]="isSubmitting || previewing || uploadingForSave">บันทึก</button>
  }
</div>
